export default __webpack_public_path__ + "static/media/octopus-rain.414394bb.png";